module.exports = __webpack_public_path__ + "static/media/icon-teams-desktop.ba21f3d0.svg";